import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instance26x4wee5nyx6a as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.k3v_1 = 8192;
        this.l3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.n3v_1 = 0;
  _this__u8e3s4.o3v_1 = 0;
  _this__u8e3s4.p3v_1 = false;
  _this__u8e3s4.q3v_1 = false;
  _this__u8e3s4.r3v_1 = null;
  _this__u8e3s4.s3v_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static t3v() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.m3v_1 = new Int8Array(8192);
        $this.q3v_1 = true;
        $this.p3v_1 = false;
        return $this;
      }
      static u3v(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.m3v_1 = data;
        $this.n3v_1 = pos;
        $this.o3v_1 = limit;
        $this.p3v_1 = shared;
        $this.q3v_1 = owner;
        return $this;
      }
      v3v() {
        this.p3v_1 = true;
        return Segment().u3v(this.m3v_1, this.n3v_1, this.o3v_1, true, false);
      }
      w3v() {
        var result = !(this.r3v_1 === this) ? this.r3v_1 : null;
        ensureNotNull(this.s3v_1).r3v_1 = this.r3v_1;
        ensureNotNull(this.r3v_1).s3v_1 = this.s3v_1;
        this.r3v_1 = null;
        this.s3v_1 = null;
        return result;
      }
      x3v(segment) {
        segment.s3v_1 = this;
        segment.r3v_1 = this.r3v_1;
        ensureNotNull(this.r3v_1).s3v_1 = segment;
        this.r3v_1 = segment;
        return segment;
      }
      y3v(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.o3v_1 - this.n3v_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().s2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.v3v();
        } else {
          prefix = SegmentPool_instance.b3w();
          var tmp0 = this.m3v_1;
          var tmp2 = prefix.m3v_1;
          var tmp5 = this.n3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.n3v_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.o3v_1 = prefix.n3v_1 + byteCount | 0;
        this.n3v_1 = this.n3v_1 + byteCount | 0;
        ensureNotNull(this.s3v_1).x3v(prefix);
        return prefix;
      }
      c3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.s3v_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.s3v_1).q3v_1)
          return Unit_instance;
        var byteCount = this.o3v_1 - this.n3v_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.s3v_1).o3v_1 | 0) + (ensureNotNull(this.s3v_1).p3v_1 ? 0 : ensureNotNull(this.s3v_1).n3v_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.d3w(ensureNotNull(this.s3v_1), byteCount);
        this.w3v();
        SegmentPool_instance.e3w(this);
      }
      d3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.q3v_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.o3v_1 + byteCount | 0) > 8192) {
          if (sink.p3v_1)
            throw IllegalArgumentException().xd();
          if (((sink.o3v_1 + byteCount | 0) - sink.n3v_1 | 0) > 8192)
            throw IllegalArgumentException().xd();
          var tmp0 = sink.m3v_1;
          var tmp2 = sink.m3v_1;
          var tmp5 = sink.n3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.o3v_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.o3v_1 = sink.o3v_1 - sink.n3v_1 | 0;
          sink.n3v_1 = 0;
        }
        var tmp0_0 = this.m3v_1;
        var tmp2_0 = sink.m3v_1;
        var tmp4 = sink.o3v_1;
        var tmp6 = this.n3v_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.n3v_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.o3v_1 = sink.o3v_1 + byteCount | 0;
        this.n3v_1 = this.n3v_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.t3v);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
